var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegSuccessImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 107,
    viewBox: "0 0 83 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.0676 2.40576C61.3976 1.55427 62.6024 1.55427 62.9324 2.40576L64.5472 6.57211C64.6891 6.93818 65.032 7.18736 65.4241 7.20918L69.8855 7.45745C70.7973 7.50819 71.1696 8.65403 70.4617 9.23102L66.9983 12.0542C66.694 12.3023 66.563 12.7055 66.6634 13.085L67.8059 17.4048C68.0394 18.2877 67.0647 18.9958 66.2972 18.5009L62.5419 16.0794C62.212 15.8667 61.788 15.8667 61.4581 16.0794L57.7028 18.5009C56.9353 18.9958 55.9606 18.2877 56.1941 17.4048L57.3366 13.085C57.437 12.7055 57.306 12.3023 57.0017 12.0542L53.5383 9.23102C52.8304 8.65403 53.2027 7.50819 54.1145 7.45745L58.576 7.20918C58.968 7.18736 59.3109 6.93818 59.4528 6.57211L61.0676 2.40576Z",
    fill: "#EDE648"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 60.5C1 58.8431 2.34315 57.5 4 57.5H20V105.5H4C2.34315 105.5 1 104.157 1 102.5V60.5Z",
    fill: "#009688",
    fillOpacity: 0.1,
    stroke: "#009688",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 29L20 58V105.5H66.4281C67.9947 105.5 69.4172 104.585 70.0674 103.16L81.6393 77.7908C81.877 77.2697 82 76.7036 82 76.1308V67C82 64.7909 80.2091 63 78 63H44.5L50.7101 42.4291C51.8564 38.6318 51.4521 34.5351 49.5855 31.0352L48.5 29Z",
    stroke: "#009688",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 47.5,
    r: 3.5,
    fill: "#009688",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 18,
    r: 4,
    stroke: "#009688",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegSuccessImg);
export default __webpack_public_path__ + "static/media/regSuccessImg.64e18e2f29268ce1a06f2f5eae3db0ad.svg";
export { ForwardRef as ReactComponent };